<div class="unauthorized-container">
  <h1>401</h1>
  <h2>Unauthorized Access</h2>
  <p>You are not authorized to access this page.</p>
  <p>Redirecting to login...</p>
</div>
